<template>
  <b-modal
    id="create"
    hide-footer
    no-close-on-backdrop
    size="lg"
    modal-class="modern-modal"
  >
    <template v-slot:modal-title>
      <div class="modal-title-modern">
        <i class="fas fa-calendar-plus mr-2"></i>
        Cadastrar Agendamento
      </div>
    </template>

    <div class="modal-content-modern">
      <form @submit.prevent="create">
        <div class="form-grid">
          <!-- Tipo de Agendamento -->
          <div class="full-width">
            <LabelRequiredField label="Tipo de Agendamento" />
            <v-select
              v-model="schedule_type_id"
              :items="schedules_types"
              item-text="name"
              item-value="id"
              clearable
              outlined
              class="modern-select"
              placeholder="Selecione o tipo de agendamento"
            />
          </div>

          <!-- Residentes -->
          <div class="full-width">
            <LabelRequiredField label="Residente(s)" />
            <v-select
              v-model="residents_ids"
              :items="residents"
              item-text="name"
              item-value="id"
              multiple
              clearable
              outlined
              ref="residentSelect"
              @change="closeSelect"
              class="modern-select"
              placeholder="Selecione os residentes"
            />
          </div>

          <!-- Data do Agendamento -->
          <div class="form-group">
            <LabelRequiredField label="Data do agendamento" />
            <div class="input-wrapper">
              <i class="fas fa-calendar input-icon"></i>
              <input
                type="date"
                v-model="date"
                class="modern-form-input"
                placeholder="Selecione a data"
              />
            </div>
          </div>

          <!-- Informar Horário -->
          <div class="form-group">
            <label class="form-label">
              <i class="fas fa-clock mr-2"></i>
              Informar horário do Agendamento?
            </label>
            <div class="radio-group">
              <div class="radio-option">
                <input
                  type="radio"
                  id="horarioSim"
                  :value="true"
                  v-model="hasTime"
                  class="modern-radio"
                />
                <label for="horarioSim" class="radio-label">
                  <span class="radio-custom"></span>
                  <span class="radio-text">Sim</span>
                </label>
              </div>
              <div class="radio-option">
                <input
                  type="radio"
                  id="horarioNao"
                  :value="false"
                  v-model="hasTime"
                  @change="cleanTime"
                  class="modern-radio"
                />
                <label for="horarioNao" class="radio-label">
                  <span class="radio-custom"></span>
                  <span class="radio-text">Não</span>
                </label>
              </div>
            </div>
          </div>

          <!-- Horários (se hasTime = true) -->
          <div v-if="hasTime" class="form-group full-width">
            <div class="time-inputs-grid">
              <div class="time-input-group">
                <label class="form-label">
                  <i class="fas fa-play mr-2"></i>
                  Horário Inicial
                </label>
                <div class="input-wrapper">
                  <i class="fas fa-clock input-icon"></i>
                  <input
                    type="time"
                    v-model="time_init"
                    class="modern-form-input"
                  />
                </div>
              </div>
              <div class="time-input-group">
                <label class="form-label">
                  <i class="fas fa-stop mr-2"></i>
                  Horário Final
                </label>
                <div class="input-wrapper">
                  <i class="fas fa-clock input-icon"></i>
                  <input
                    type="time"
                    v-model="time_end"
                    class="modern-form-input"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Observação -->
          <div class="form-group full-width">
            <label class="form-label">
              <i class="fas fa-sticky-note mr-2"></i>
              Observação
            </label>
            <div class="textarea-wrapper">
              <i class="fas fa-comment textarea-icon"></i>
              <textarea
                v-model="note"
                class="modern-form-textarea"
                placeholder="Adicione observações sobre o agendamento"
                rows="4"
              />
            </div>
          </div>
        </div>

        <!-- Errors -->
        <div class="errors-section" v-if="errors.length > 0">
          <ErrorsMessages :errors="errors" />
        </div>

        <!-- Form Actions -->
        <div class="form-actions">
          <v-btn :disabled="loading" type="submit" class="btn-save-modern">
            <i class="fas fa-save mr-2"></i>
            {{ loading ? "Salvando..." : "Salvar Agendamento" }}
          </v-btn>
        </div>
      </form>
    </div>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import LabelRequiredField from "../Components/LabelRequiredField";
import api from "../../services/api";
import toast from "../../lib/ToastNotification";

export default {
  name: "CreateModal",

  components: {
    LabelRequiredField,
    ErrorsMessages,
  },

  data() {
    return {
      errors: [],
      residents_ids: [],
      schedule_type_id: null,
      date: "",
      hasTime: false,
      time_init: "",
      time_end: "",
      note: "",
      loading: false,
    };
  },

  props: {
    schedules_types: {
      type: Array,
      default: () => [],
    },
    residents: {
      type: Array,
      default: () => [],
    },
    resident_id: {
      type: Number,
      default: null,
    },
  },

  watch: {
    resident_id(residentId) {
      if (residentId) {
        this.residents_ids = [Number(residentId)];
      }
    },
  },

  mounted() {
    if (this.resident_id) {
      this.residents_ids = [Number(this.resident_id)];
    }
  },

  methods: {
    async create() {
      try {
        this.loading = true;

        const {
          schedule_type_id,
          residents_ids,
          date,
          time_init,
          time_end,
          note,
        } = this;

        let params = {
          schedule_type_id,
          residents_ids,
          date,
          time_init,
          time_end,
          note,
        };

        const response = await api.post("/schedule", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("create");
          this.resetForm();
          toast(message, "success");
          this.$emit("create");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    resetForm() {
      this.errors = [];
      this.schedule_type_id = null;
      this.residents_ids = [];
      this.date = "";
      this.time_init = "";
      this.time_end = "";
      this.note = "";
      this.hasTime = false;
    },

    cardClicked(info) {
      this.$emit("update", info.event.extendedProps.schedule.id);
    },

    cleanTime() {
      this.time_init = "";
      this.time_end = "";
      this.errors = [];
    },

    closeSelect() {
      this.$refs.residentSelect.blur();
    },
  },
};
</script>

<style scoped>
/* Modal Styling */
.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.modal-content-modern {
  padding: 8px 0;
}

/* Form Grid */
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

/* Labels */
.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 0;
  display: flex;
  align-items: center;
}

.form-label i {
  color: #0f65b0;
}

/* Input Wrappers */
.input-wrapper,
.select-wrapper,
.textarea-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon,
.select-icon,
.textarea-icon {
  position: absolute;
  left: 12px;
  color: #6b7280;
  font-size: 14px;
  z-index: 1;
}

.textarea-icon {
  top: 16px;
  left: 12px;
}

/* Modern Inputs */
.modern-form-input,
.modern-form-textarea {
  width: 100%;
  border: 2px solid #e5e7eb !important;
  border-radius: 8px !important;
  padding: 12px 16px 12px 40px !important;
  font-size: 14px !important;
  transition: all 0.3s ease !important;
  background: white !important;
}

.modern-form-input:focus,
.modern-form-textarea:focus {
  border-color: #0f65b0 !important;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1) !important;
  outline: none !important;
}

.modern-form-textarea {
  resize: vertical;
  min-height: 100px;
  padding-top: 16px !important;
}

/* Time Inputs Grid */
.time-inputs-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.time-input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Radio Buttons */
.radio-group {
  display: flex;
  gap: 20px;
  margin-top: 4px;
}

.radio-option {
  display: flex;
  align-items: center;
}

.modern-radio {
  display: none;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  user-select: none;
}

.radio-custom {
  width: 18px;
  height: 18px;
  border: 2px solid #e5e7eb;
  border-radius: 50%;
  position: relative;
  transition: all 0.3s ease;
  background: white;
}

.radio-custom::after {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #0f65b0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.2s ease;
}

.modern-radio:checked + .radio-label .radio-custom {
  border-color: #0f65b0;
  background: white;
}

.modern-radio:checked + .radio-label .radio-custom::after {
  transform: translate(-50%, -50%) scale(1);
}

.radio-label:hover .radio-custom {
  border-color: #0f65b0;
}

.radio-text {
  font-weight: 500;
}

/* Form Actions */
.form-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 24px;
  border-top: 1px solid #e5e7eb;
  margin-top: 24px;
}

.btn-save-modern {
  background: linear-gradient(135deg, #1e884d 0%, #16a34a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 14px 32px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(30, 136, 77, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-save-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(30, 136, 77, 0.4) !important;
}

.btn-save-modern:disabled {
  opacity: 0.7 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

/* Errors Section */
.errors-section {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fca5a5;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .time-inputs-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .radio-group {
    flex-direction: column;
    gap: 12px;
  }

  .modal-content-modern {
    padding: 0;
  }

  .form-actions {
    padding-top: 20px;
  }

  .btn-save-modern {
    width: 100% !important;
    padding: 12px 24px !important;
  }
}

@media (max-width: 480px) {
  .modal-title-modern {
    font-size: 18px;
    flex-direction: column;
    gap: 4px;
  }

  .form-label {
    font-size: 13px;
  }

  .modern-form-input,
  .modern-form-textarea {
    padding: 10px 14px 10px 36px !important;
    font-size: 13px !important;
  }

  .input-icon,
  .select-icon,
  .textarea-icon {
    left: 10px;
    font-size: 13px;
  }
}

/* Override Vuetify styles */
.modern-select >>> .v-input__control {
  border-radius: 8px !important;
}

.modern-select >>> .v-text-field__slot {
  padding-left: 40px !important;
}

.modern-select >>> .v-input__slot {
  border: 2px solid #e5e7eb !important;
  border-radius: 8px !important;
  background: white !important;
  padding: 10px;
}

.modern-select >>> .v-input--is-focused .v-input__slot {
  border-color: #0f65b0 !important;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1) !important;
}

.modern-select >>> .v-text-field input,
.modern-select >>> .v-select__selection {
  font-weight: 500 !important;
  color: #374151 !important;
}

.modern-select >>> .v-input__append-inner {
  margin-top: 0 !important;
  align-self: center !important;
}

/* Modal Header Override */
.modern-modal >>> .modal-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
  border-bottom: 1px solid #e5e7eb !important;
  border-radius: 0 !important;
  padding: 20px 24px !important;
}

.modern-modal >>> .modal-body {
  padding: 24px !important;
}

.modern-modal >>> .modal-content {
  border-radius: 16px !important;
  border: none !important;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15) !important;
}
</style>